import { lazy } from 'react';
import { GarageGate } from '../lib/gate.js';

// Écran chargé à la demande : le portail client et la connexion n'en téléchargent pas le code.
const HomeScreen = lazy(() => import('../screens/HomeScreen.js'));

/** Accueil (espace garage). */
export default function HomePage() {
  return (
    <GarageGate>
      <HomeScreen />
    </GarageGate>
  );
}
